import _ from 'lodash';

const progressUtils = {
  getProgressCount(checkpointNodes, previouslyViewedNodes) {
    const previouslyViewedNodeIds = [... new Set(previouslyViewedNodes.map(userNode => userNode._node))];
    return _.countBy(checkpointNodes, (n) => previouslyViewedNodeIds.indexOf(n._id) > -1);
  }
  , getProgressPercent(checkpointNodes, previouslyViewedNodes, hasValidCert) {
    if(hasValidCert) {
      return 100;
    }
    const previouslyViewedNodeIds = [... new Set(previouslyViewedNodes.map(userNode => userNode._node))];
    const progressCount = _.countBy(checkpointNodes, (n) => previouslyViewedNodeIds.indexOf(n._id) > -1);
    return progressCount.true && checkpointNodes.length > 0 ? Math.round((progressCount.true / checkpointNodes.length) * 100) : 0;
  }
}

export default progressUtils;



// WEBPACK FOOTER //
// global/utils/progressUtils.js